// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import VueTimepicker from 'vue2-timepicker'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import VueMomentJS from 'vue-momentjs'
import 'bootstrap'
import 'animate.css'

// Setup basic Axios info
var baseUrl = ''
if (process.env.NODE_ENV === 'production') {
    baseUrl = 'https://openfreight.com.au/api/v2/bap'
} else if (process.env.NODE_ENV === 'qa') {
    baseUrl = 'https://qa.openfreight.com.au/api/v2/bap'
} else {
    baseUrl = 'http://dev.openfreight.com.au/api/v2/bap'
}

// Setup basic Axios info
let axios = Axios.create({
    baseURL: baseUrl,
    crossdomain: true,
    headers: {
        'Content-Type': 'application/json'
    }
})

// Vue Config
Vue.config.productionTip = false

Vue.use(VueAxios, axios)
Vue.use(VueTimepicker)
Vue.use(VueMomentJS, moment, momentTimezone)

// Setup the Vue APP
/* eslint-disable no-new */
new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
